export default {
  title: "データ連携",
  date: "日付"
}
